import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { auth, storage } from '../../config/firebase';

/** Extrai mensagem legível de erros Firebase (Storage / Functions). */
export function mensagemErroFirebase(e, fallback = 'Erro ao registrar o apontamento.') {
  if (!e) return fallback;
  const code = String(e.code || '');
  const details = typeof e.details === 'string' ? e.details.trim() : '';
  const msg = String(e.message || '').trim();

  if (code === 'storage/unauthorized' || code === 'storage/unauthenticated') {
    return 'Sem permissão para enviar a foto. Faça login novamente e tente outra vez.';
  }
  if (code === 'storage/canceled') {
    return 'Envio da foto cancelado.';
  }
  if (code === 'storage/retry-limit-exceeded' || code === 'storage/unknown') {
    return 'Falha de rede ao enviar a foto. Verifique a conexão e tente novamente.';
  }
  if (details) return details;
  // Callable: "Firebase: Error (functions/failed-precondition)." — preferir texto útil
  const m = msg.match(/Firebase:\s*(.+?)(?:\s*\(|$)/i);
  if (m && m[1] && !/^Error$/i.test(m[1].trim())) return m[1].trim();
  if (msg && !/^Firebase:\s*Error/i.test(msg)) return msg;
  if (code.startsWith('functions/')) {
    return msg.replace(/^Firebase:\s*/i, '') || fallback;
  }
  return msg || fallback;
}

/** Sobe a foto do apontamento (câmera frontal) e retorna a URL pública. */
export async function uploadApontamentoFoto(blobOrFile, { empresaId, setorId }) {
  if (!auth.currentUser) {
    throw new Error('Sessão expirada. Faça login novamente para enviar a foto.');
  }
  const emp = String(empresaId || '').trim();
  if (!emp || emp === 'default') {
    throw new Error('Empresa não identificada. Recarregue a página e entre novamente.');
  }
  if (!blobOrFile || (typeof blobOrFile.size === 'number' && blobOrFile.size < 32)) {
    throw new Error('A foto capturada está vazia. Tente novamente olhando para a câmera.');
  }

  const timestamp = Date.now();
  const randomId = Math.random().toString(36).substring(2, 10);
  const safeSetor = String(setorId || 'setor').replace(/[^a-zA-Z0-9_-]/g, '_').slice(0, 30);
  const fname = `${safeSetor}_${timestamp}_${randomId}.jpg`;
  const storageRef = ref(storage, `producao_apontamentos/${emp}/${fname}`);

  const contentType =
    (blobOrFile.type && String(blobOrFile.type).startsWith('image/'))
      ? blobOrFile.type
      : 'image/jpeg';

  try {
    await uploadBytes(storageRef, blobOrFile, { contentType });
    return await getDownloadURL(storageRef);
  } catch (e) {
    throw new Error(mensagemErroFirebase(e, 'Não foi possível enviar a foto para o armazenamento.'));
  }
}

/** mm:ss a partir de um Timestamp/Date/{seconds} de início. */
export function formatarCronometro(inicio, agoraMs) {
  const ms = tsParaMs(inicio);
  if (ms == null) return '00:00';
  const diff = Math.max(0, Math.floor((agoraMs - ms) / 1000));
  const m = Math.floor(diff / 60);
  const s = diff % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

export function tsParaMs(val) {
  if (val == null) return null;
  if (typeof val === 'object') {
    if (typeof val.toDate === 'function') return val.toDate().getTime();
    if (typeof val.seconds === 'number') return val.seconds * 1000;
    if (typeof val._seconds === 'number') return val._seconds * 1000;
    if (val instanceof Date) return val.getTime();
  }
  if (typeof val === 'string') {
    const d = new Date(val);
    return Number.isNaN(d.getTime()) ? null : d.getTime();
  }
  return null;
}

export function ordenarPorLote(a, b) {
  return (
    String(a.lote_fabricacao || '').localeCompare(String(b.lote_fabricacao || ''), 'pt-BR') ||
    String(a.lote_carrinho || '').localeCompare(String(b.lote_carrinho || ''), 'pt-BR')
  );
}
